






























































































































import Vue from "vue";
import Component from "vue-class-component";
import navigation from "@/assets/navigation.json";
@Component({
  name: "Layout"
  // Toutes les options de composant sont autorisées ici.
})
export default class Layout extends Vue {
  drawer = true;
  items = navigation;
  links = ["Home", "About Us", "Team", "Services", "Blog", "Contact Us"];

  chapters = [
    "Design Resilient Architectures",
    "Define Performant Architectures",
    "Specify Secure Applications and Architectures",
    "Design Cost-Optimized Architectures",
    "Define Operationally Excellent Architectures",
    "Practice Test"
  ];
  created() {
    if (localStorage.getItem("quizzes")) {
      try {
        this.$store.state.quizzes = JSON.parse(
          localStorage.getItem("quizzes") as string
        );
      } catch (e) {
        localStorage.removeItem("quizzes");
        this.$store.state.quizzes = require("@/assets/quizzes.json");
        localStorage.setItem(
          "quizzes",
          JSON.stringify(this.$store.state.quizzes)
        );
      }
    } else {
      this.$store.state.quizzes = require("@/assets/quizzes.json");
      localStorage.setItem(
        "quizzes",
        JSON.stringify(this.$store.state.quizzes)
      );
    }
  }

  right = false;
  miniVariant = true;
  expandOnHover = true;
  background = false;
}
